function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { isBuffer as i } from "../../predicate/isBuffer.js";
import { isPrototype as s } from "../_internal/isPrototype.js";
import { isArrayLike as o } from "../predicate/isArrayLike.js";
import { isTypedArray as u } from "../predicate/isTypedArray.js";
import { times as y } from "../util/times.js";
function h(r) {
  if (r == null) return [];
  switch (_typeof(r)) {
    case "object":
    case "function":
      return o(r) ? d(r) : s(r) ? a(r) : n(r);
    default:
      return n(Object(r));
  }
}
function n(r) {
  var e = [];
  for (var t in r) e.push(t);
  return e;
}
function a(r) {
  return n(r).filter(function (t) {
    return t !== "constructor";
  });
}
function d(r) {
  var e = y(r.length, function (f) {
      return "".concat(f);
    }),
    t = new Set(e);
  return i(r) && (t.add("offset"), t.add("parent")), u(r) && (t.add("buffer"), t.add("byteLength"), t.add("byteOffset")), [].concat(_toConsumableArray(e), _toConsumableArray(n(r).filter(function (f) {
    return !t.has(f);
  })));
}
export { h as keysIn };